module.exports = __webpack_public_path__ + "img/rx.750b7c5e.jpg";